<template>
  <LoginOrReg class="login">
    <Form class="form">
      <UsernameInput v-model="username"/>
      <PasswordInput v-model="password" class="mt-4"/>

      <van-button
        class="!mt-10 primaryBtn submit"
        :disabled="!canSubmit"
        @click="onSubmit"
      > {{ $t('LoginOrReg.Login') }} </van-button>

      <!-- <img
        src="./images/b_login.png"
        class="wh-[235px_22px] mx-auto mt-8"
      />

      <div class="flex-between m-[36px_12px_0]">
        <div
          class="size-14 flex-center bgs-[url('@a/assets/images/bg_logo.png')]"
          v-for="item in config.mediaList.filter(item => item.mediaName !== '18')"
          :key="item.mediaName"
        >
          <Image :src="item.imgUrl" class="size-8" />
        </div>
      </div> -->
    </Form>
  </LoginOrReg>
</template>

<script setup lang="ts">
  import LoginOrReg from '@/components/LoginOrReg/index.vue'
  import UsernameInput from '@a/components/FormInput/usernameInput.vue';
  import PasswordInput from '@a/components/FormInput/passwordInput.vue';
  import Form from 'vant/lib/form';
  import debounce from 'lodash-es/debounce'
  import { login } from '@/api'
  import { encryptPassword } from '@/utils'
  import { useUserInfo } from '@/store'
  import { isInPWA } from '@/env'
  import useTrack from '@/hooks/useTrack.ts'

  const userInfo = useUserInfo()

  const username = ref('');
  const password = ref('');

  const onSubmit = debounce(async () => {
    if (!canSubmit.value) return

    const params = {
      username: username.value,
      password: encryptPassword(password.value),
      pwa: isInPWA
    }

    try {
      showLoadingToast('logando...');
      const { code, data } = await login(params)
      if (code === 1 && data) {
        userInfo.login(data.user, data.token)

        const {track2Platform, trackName} = useTrack()
        setTimeout(() => {
          track2Platform(trackName.SubmitApplication)
        }, 200)

        showToast({
          type: 'success',
          iconSize: 30,
          message: 'sucesso',
          onClose: () => {
            history.back()
          }
        })
      }
    } catch (error) {
      console.error(error)
    }
  }, 500)

  const validateMap = ref({
    username: 0,
    password: 0,
  })

  provide('validateMap', validateMap)

  const canSubmit = computed(() => Object.values(validateMap.value).every(item => item === 1))
</script>

<style lang="scss" scoped>
  .login .form{
    @apply bgs-[var(--login-bg)] pt-[175px] px-4;
  }
</style>
